// extracted by mini-css-extract-plugin
export default {"container":"ExplainHeader_container__xHTvz","title":"ExplainHeader_title__5bohi","subtitle":"ExplainHeader_subtitle__x7hF5","icon":"ExplainHeader_icon__To4dk"};